import { c as _c } from "react/compiler-runtime";
import { useReducedMotion } from "motion/react";
import { useEffect, useState } from "react";
import { RAIL_TRANSITION_EASING, RAIL_WIDTH_TRANSITION_MS } from "./sidebar/railConstants";
export const BlacksmithLogoSVG = t0 => {
  const $ = _c(2);
  const {
    oneline: t1
  } = t0;
  const oneline = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== oneline) {
    t2 = oneline ? <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1154 96"><title>Blacksmith</title><path fill="currentColor" d="M144 0v96H48c0-26.51-21.49-48-48-48V0h144Z" /><path fill="currentColor" fillRule="evenodd" d="M261.075 13.474h13.479v28.632h-13.479v11.788h13.479v28.632h-13.479V96H192V53.895h13.479v-11.79H192V0h69.075v13.474Zm-53.912 67.368h52.228V55.579h-52.228v25.263Zm0-40.421h52.228V15.158h-52.228v25.263Z" clipRule="evenodd" /><path fill="currentColor" d="M304.879 80.842h53.913V96h-69.076V0h15.163v80.842Z" /><path fill="currentColor" fillRule="evenodd" d="M443.029 13.474h13.479V96h-15.163V55.58h-52.228V96h-15.163V13.474h13.479V0h55.596v13.474ZM389.117 40.42h52.228V15.158h-52.228v25.263Z" clipRule="evenodd" /><path fill="currentColor" d="M540.746 13.474h13.479v15.158h-15.163V15.158h-52.228v65.684h52.228V67.368h15.163v15.158h-13.479V96h-55.598V82.526h-13.477V13.474h13.477V0h55.598v13.474ZM584.55 40.42h38.75V26.948h13.477V0h15.163v28.632h-13.478v13.473h-13.478v11.79h13.478v13.473h13.478V96h-15.163V69.053H623.3V55.579h-38.75V96h-15.163V0h15.163v40.42ZM736.179 13.474h13.478v15.158h-15.163V15.158h-52.227v25.263h53.912v13.474h13.478v28.631h-13.478V96h-55.598V82.526h-13.477V67.368h15.163v13.474h52.227V55.579h-53.913V42.105h-13.477V13.474h13.477V0h55.598v13.474ZM806.938 13.474h11.794V0h28.641v13.474h13.479V96h-15.164V15.158h-25.271V96h-15.163V15.158h-25.272V96h-15.163V13.474h13.479V0h28.64v13.474ZM904.655 13.474h11.793V0h28.641v15.158h-26.956v65.684h26.956V96h-28.641V82.526h-11.793V96h-28.641V80.842h26.957V15.158h-26.957V0h28.641v13.474ZM1002.37 13.474h11.8V0h42.11v15.158h-40.43V96h-15.16V15.158h-40.438V0h42.118v13.474ZM1086.61 40.42h52.23V0H1154v96h-15.16V55.58h-52.23V96h-15.16V0h15.16v40.42Z" /></svg> : <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 96" fill="none"><title>Blacksmith</title><g fill="currentColor"><path d="M214.062 57.732h6.256v7.029h-7.038v-6.248h-24.242v11.715h25.024v6.248h6.256v13.276h-6.256V96h-25.806v-6.248h-6.257v-7.029h7.039v6.248h24.242V77.256h-25.024v-6.248h-6.257V57.732h6.257v-6.248h25.806v6.248ZM246.906 57.732h5.474v-6.248h13.295v6.248h6.255V96h-7.038V58.513h-11.73V96h-7.038V58.513h-11.73V96h-7.038V57.732h6.256v-6.248h13.294v6.248ZM292.263 57.732h5.474v-6.248h13.294v7.029h-12.512V88.97h12.512V96h-13.294v-6.248h-5.474V96h-13.294v-7.029h12.512V58.513h-12.512v-7.03h13.294v6.249ZM337.619 57.732h5.474v-6.248h19.551v7.029h-18.768V96h-7.039V58.513h-18.768v-7.03h19.55v6.249ZM376.719 70.228h24.243V51.484H408V96h-7.038V77.256h-24.243V96h-7.037V51.484h7.037v18.744ZM144 95.937H48l-.016-1.238C47.327 68.796 26.095 48 0 48V.063h144v95.874Z" /><path fillRule="evenodd" d="M214.062 6.248h6.256v13.276h-6.256v5.468h6.256v13.276h-6.256v6.248h-32.063V24.992h6.257v-5.468h-6.257V0h32.063v6.248Zm-25.024 31.24h24.242V25.772h-24.242v11.714Zm0-18.744h24.242V7.029h-24.242v11.715Z" clipRule="evenodd" /><path d="M237.516 37.487h25.024v7.03h-32.062V0h7.038v37.487Z" /><path fillRule="evenodd" d="M304.763 6.248h6.256v38.268h-7.038V25.773h-24.242v18.743h-7.038V6.248h6.256V0h25.806v6.248Zm-25.024 12.496h24.242V7.029h-24.242v11.715Z" clipRule="evenodd" /><path d="M353.241 6.248h6.257v7.029h-7.038V7.029h-24.243v30.458h24.243V31.24h7.038v7.03h-6.257v6.247h-25.806v-6.248h-6.256V6.248h6.256V0h25.806v6.248ZM376.696 18.744h17.986v-6.248h6.256V0h7.038v13.277h-6.256v6.247h-6.256v5.468h6.256v6.247h6.256v13.277h-7.038V32.021h-6.256v-6.248h-17.986v18.743h-7.038V0h7.038v18.744Z" /></g></svg>;
    $[0] = oneline;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export const BlacksmithLogomarkSVG = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 96" fill="none"><title>Blacksmith</title><path fill="currentColor" d="M144 95.937H48l-.016-1.238C47.327 68.796 26.095 48 0 48V.063h144v95.874Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};

// The individual pixel boxes that make up the "BLACKSMITH" wordmark, in SVG
// user units (viewBox 0 0 152 15). Kept as data (not inline JSX) so each box
// can be revealed on its own for the pixelated build-in animation.
type WordmarkRect = {
  x?: number;
  y?: number;
  width: number;
  height: number;
  transform?: string;
};
const BLACKSMITH_WORDMARK_RECTS: WordmarkRect[] = [{
  x: 59.5264,
  width: 2.36842,
  height: 15
}, {
  x: 61.8948,
  y: 6.31543,
  width: 6.31579,
  height: 2.36842
}, {
  x: 68.0527,
  y: 4.2627,
  width: 2.36842,
  height: 2.21053
}, {
  x: 68.0527,
  y: 8.52637,
  width: 2.36842,
  height: 2.21053
}, {
  x: 70.1052,
  y: 10.5791,
  width: 2.36842,
  height: 4.42105
}, {
  x: 70.1052,
  width: 2.36842,
  height: 4.42105
}, {
  x: 54.7896,
  y: 10.5791,
  width: 2.36842,
  height: 2.36842
}, {
  x: 46.2632,
  width: 8.68421,
  height: 2.36842
}, {
  x: 54.7896,
  y: 2.05273,
  width: 2.36842,
  height: 2.36842
}, {
  x: 44.0527,
  y: 2.05273,
  width: 2.36842,
  height: 10.8947
}, {
  x: 46.2632,
  y: 12.6318,
  width: 8.68421,
  height: 2.36842
}, {
  x: 30.7896,
  width: 8.68421,
  height: 2.36842
}, {
  x: 30.7896,
  y: 6.31543,
  width: 8.68421,
  height: 2.36842
}, {
  x: 28.7368,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  x: 39.3157,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  width: 10.8947,
  height: 2.36842
}, {
  x: 2.05273,
  y: 6.31543,
  width: 8.8421,
  height: 2.36842
}, {
  x: 2.05273,
  y: 12.6318,
  width: 8.8421,
  height: 2.36842
}, {
  y: 15,
  width: 6.63158,
  height: 2.36842,
  transform: "rotate(-90 0 15)"
}, {
  x: 10.5789,
  y: 12.9473,
  width: 4.42105,
  height: 2.36842,
  transform: "rotate(-90 10.5789 12.9473)"
}, {
  x: 10.5789,
  y: 6.47363,
  width: 4.42105,
  height: 2.36842,
  transform: "rotate(-90 10.5789 6.47363)"
}, {
  y: 6.47363,
  width: 4.42105,
  height: 2.36842,
  transform: "rotate(-90 0 6.47363)"
}, {
  x: 15.3157,
  y: 12.6318,
  width: 10.8947,
  height: 2.36842
}, {
  x: 15.3157,
  y: 15,
  width: 15,
  height: 2.36842,
  transform: "rotate(-90 15.3157 15)"
}, {
  x: 77.0527,
  width: 8.8421,
  height: 2.36842
}, {
  x: 75,
  y: 2.05273,
  width: 2.36842,
  height: 4.42105
}, {
  x: 85.5789,
  y: 2.05273,
  width: 2.36842,
  height: 2.36842
}, {
  x: 77.0527,
  y: 6.31543,
  width: 8.8421,
  height: 2.36842
}, {
  x: 85.5789,
  y: 8.52637,
  width: 2.36842,
  height: 4.42105
}, {
  x: 77.0527,
  y: 12.6318,
  width: 8.8421,
  height: 2.36842
}, {
  x: 75,
  y: 10.5791,
  width: 2.36842,
  height: 2.36842
}, {
  x: 90.3157,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  x: 92.5261,
  width: 4.42105,
  height: 2.36842
}, {
  x: 98.842,
  width: 4.57895,
  height: 2.36842
}, {
  x: 96.7893,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  x: 103.105,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  x: 108,
  width: 4.57895,
  height: 2.36842
}, {
  x: 114.316,
  width: 4.57895,
  height: 2.36842
}, {
  x: 108,
  y: 12.6318,
  width: 4.57895,
  height: 2.36842
}, {
  x: 114.316,
  y: 12.6318,
  width: 4.57895,
  height: 2.36842
}, {
  x: 112.263,
  y: 2.05273,
  width: 2.36842,
  height: 10.8947
}, {
  x: 121.263,
  width: 6.63158,
  height: 2.36842
}, {
  x: 127.579,
  y: 2.05273,
  width: 2.36842,
  height: 12.9474
}, {
  x: 129.79,
  width: 6.63158,
  height: 2.36842
}, {
  x: 138.79,
  width: 2.36842,
  height: 15
}, {
  x: 151.737,
  y: 6.1582,
  width: 2.36842,
  height: 12.9474,
  transform: "rotate(90 151.737 6.1582)"
}, {
  x: 149.368,
  width: 2.36842,
  height: 15
}];

// Rightmost x among the boxes; each box's reveal timing is driven by its x
// position so the word writes itself in left-to-right.
const WORDMARK_MAX_X = Math.max(...BLACKSMITH_WORDMARK_RECTS.map(r => r.x ?? 0));
// Stagger window over which boxes start appearing (left-to-right). The last
// boxes land at ~WORDMARK_REVEAL_MS, then fade in over WORDMARK_FADE_IN_MS, so
// the overall build is ~450ms.
const WORDMARK_REVEAL_MS = 410;
// Each box fades in over this window once its staggered delay elapses, softening
// the arrival of the many small boxes so it reads smooth rather than flickery.
const WORDMARK_FADE_IN_MS = 40;
// On close the whole wordmark fades out together (a subtle crossfade to the
// emblem) rather than replaying the pixel build in reverse.
const WORDMARK_FADE_OUT_MS = 100;
// Ease applied to each box's x-driven delay: delay = xNorm^power · REVEAL. A
// power > 1 makes the left-to-right sweep start brisk and gently decelerate as
// it reaches the right edge. (Higher = more deceleration.)
const WORDMARK_EASE_POWER = 1.7;
// Per-box random deviation (fraction of the reveal window), re-rolled each open,
// so the left-to-right sweep isn't a rigid wipe — boxes near each other pop in a
// slightly organic, non-mechanical order.
const WORDMARK_JITTER_FRACTION = 0.12;
// Each box appears one box-length off its final spot, holds there for this brief
// window, then slides into its final position.
const WORDMARK_HOLD_MS = 100;
// Duration of the slide from `offset` to the final position.
const WORDMARK_SLIDE_MS = 100;
// Only the last (rightmost) few boxes slide in from the left; the rest just
// appear in place. Set to 0 to disable sliding entirely.
const WORDMARK_SLIDE_COUNT = 0;
// x cutoff for the rightmost WORDMARK_SLIDE_COUNT boxes (those slide).
const WORDMARK_SLIDE_X_THRESHOLD = [...BLACKSMITH_WORDMARK_RECTS].map(r => r.x ?? 0).sort((a, b) => b - a)[Math.min(WORDMARK_SLIDE_COUNT, BLACKSMITH_WORDMARK_RECTS.length) - 1];
// Fixed leftward distance every sliding box starts from: the average of the
// boxes' smaller dimension (their "thickness"), so the slide reads as roughly
// one stroke width regardless of the box's shape.
const WORDMARK_SLIDE_DISTANCE = BLACKSMITH_WORDMARK_RECTS.reduce((sum, r) => sum + Math.min(r.width, r.height), 0) / BLACKSMITH_WORDMARK_RECTS.length;

// Pixel-font "BLACKSMITH" wordmark. Fills inherit currentColor so it can be
// themed (dark grey in light mode, brand yellow in dark mode) by the caller.
//
// When `expanded` is true the word writes itself in left-to-right: each box's
// delay is driven by its x position (gently eased so the sweep decelerates),
// with a small per-open random jitter so it isn't a rigid wipe. Each box then
// fades in over a short window. A configurable few of the rightmost boxes can
// slide in from the left instead of appearing in place. On close the word fades
// out together (a subtle crossfade to the emblem); pass `instant` to skip that
// fade for navigation-driven closes that snap shut.
export const BlacksmithWordmarkSVG = t0 => {
  const $ = _c(10);
  const {
    className,
    expanded: t1,
    instant: t2,
    animateReveal: t3
  } = t0;
  const expanded = t1 === undefined ? true : t1;
  const instant = t2 === undefined ? false : t2;
  const animateReveal = t3 === undefined ? true : t3;
  const rollReveal = _temp2;
  const [reveal, setReveal] = useState(rollReveal);
  const [wasExpanded, setWasExpanded] = useState(expanded);
  if (expanded !== wasExpanded) {
    setWasExpanded(expanded);
    if (expanded) {
      setReveal(rollReveal());
    }
  }
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      overflow: "visible"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <title>Blacksmith</title>;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== animateReveal || $[3] !== expanded || $[4] !== instant || $[5] !== reveal) {
    t6 = BLACKSMITH_WORDMARK_RECTS.map((r, i) => {
      const jit = reveal[i];
      const xNorm = (r.x ?? 0) / WORDMARK_MAX_X;
      const base = Math.pow(xNorm, WORDMARK_EASE_POWER) * WORDMARK_REVEAL_MS;
      const jitter = (jit - 0.5) * 2 * WORDMARK_REVEAL_MS * WORDMARK_JITTER_FRACTION;
      const delay = expanded ? Math.max(0, base + jitter) : 0;
      const slides = WORDMARK_SLIDE_COUNT > 0 && (r.x ?? 0) >= WORDMARK_SLIDE_X_THRESHOLD;
      const offset = slides ? `translate(${-WORDMARK_SLIDE_DISTANCE}px, 0px)` : "translate(0px, 0px)";
      return <g key={i} style={{
        opacity: expanded ? 1 : 0,
        transform: expanded ? "translate(0px, 0px)" : offset,
        transition: expanded ? animateReveal ? `opacity ${WORDMARK_FADE_IN_MS}ms ease-out ${delay}ms, transform ${WORDMARK_SLIDE_MS}ms ease-out ${delay + WORDMARK_HOLD_MS}ms` : "none" : instant ? "opacity 0ms linear, transform 0ms linear" : `opacity ${WORDMARK_FADE_OUT_MS}ms ease-out, transform 0ms linear`
      }}><rect x={r.x} y={r.y} width={r.width} height={r.height} transform={r.transform} /></g>;
    });
    $[2] = animateReveal;
    $[3] = expanded;
    $[4] = instant;
    $[5] = reveal;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== className || $[8] !== t6) {
    t7 = <svg className={className} width="152" height="15" viewBox="0 0 152 15" fill="currentColor" overflow="visible" style={t4} xmlns="http://www.w3.org/2000/svg">{t5}{t6}</svg>;
    $[7] = className;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
export const AnimatedBlacksmithLogoOneline = () => {
  const $ = _c(14);
  const prefersReducedMotion = useReducedMotion();
  const [expanded, setExpanded] = useState(false);
  const showWordmark = prefersReducedMotion === true || expanded;
  let t0;
  let t1;
  if ($[0] !== prefersReducedMotion) {
    t0 = () => {
      if (prefersReducedMotion) {
        return;
      }
      const frame = requestAnimationFrame(() => setExpanded(true));
      return () => cancelAnimationFrame(frame);
    };
    t1 = [prefersReducedMotion];
    $[0] = prefersReducedMotion;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  const t2 = showWordmark ? 184 : 24;
  const t3 = showWordmark ? "translateX(4px)" : "translateX(84px)";
  const t4 = prefersReducedMotion ? "none" : `width ${RAIL_WIDTH_TRANSITION_MS}ms ${RAIL_TRANSITION_EASING}, transform ${RAIL_WIDTH_TRANSITION_MS}ms ${RAIL_TRANSITION_EASING}`;
  let t5;
  if ($[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
    t5 = {
      width: t2,
      transform: t3,
      transition: t4
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute left-0 top-1/2 h-4 w-6 -translate-y-1/2"><BlacksmithLogomarkSVG /></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = !prefersReducedMotion;
  let t8;
  if ($[8] !== showWordmark || $[9] !== t7) {
    t8 = <div aria-hidden={true} className="absolute left-8 top-1/2 -translate-y-1/2"><BlacksmithWordmarkSVG expanded={showWordmark} animateReveal={t7} className="h-[15px] w-[152px]" /></div>;
    $[8] = showWordmark;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t5 || $[12] !== t8) {
    t9 = <div className="relative mx-auto h-6 w-48"><div className="relative h-6 overflow-hidden" style={t5}>{t6}{t8}</div></div>;
    $[11] = t5;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};

// Phase-locks every emblem instance to a shared page-wide clock: with
// delay = epoch - now, an animation started at mount sits at
// progress = now - epoch, no matter when it mounted. Loading screens hand the
// emblem across several mounts (auth loader → sidebar skeleton → Suspense
// fallback), and this keeps them all rendering one continuous loop instead of
// restarting the animation on each remount.
//
// The epoch is first contentful paint because that is when the SSR'd
// instance's own CSS animation starts, so client-mounted instances line up
// with it. The server renders "0s", which is the correct phase for the SSR'd
// element itself; the client value is stable across renders, so React never
// patches the SSR'd attribute (suppressHydrationWarning silences the expected
// mismatch).
// Captured once so every instance shares the same epoch even when the FCP
// entry isn't available yet (first mount before paint, or a browser without
// Paint Timing); a per-call fallback would phase-offset later instances.
let pageClockEpoch: number | null = null;
const pageClockDelay = () => {
  if (typeof window === "undefined") {
    return "0s";
  }
  if (pageClockEpoch === null) {
    const fcp = performance.getEntriesByType("paint").find(e => e.name === "first-contentful-paint");
    pageClockEpoch = fcp?.startTime ?? performance.now();
  }
  return `${(pageClockEpoch - performance.now()) / 1000}s`;
};
export const BlacksmithLogomarkAnimationSVG = t0 => {
  const $ = _c(10);
  const {
    showStroke: t1,
    className
  } = t0;
  const showStroke = t1 === undefined ? true : t1;
  const [animationDelay] = useState(pageClockDelay);
  const t2 = className ?? "p-6";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <title>Blacksmith</title>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== animationDelay || $[2] !== showStroke) {
    t4 = showStroke && <g className="text-neutral-600 dark:text-primary"><path d="M144 95.937H48l-.016-1.238C47.327 68.796 26.095 48 0 48V.063h144v95.874Z" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="100,800" suppressHydrationWarning={true} style={{
        animation: "logomark-stroke-sweep 3s linear infinite",
        animationDelay
      }} /></g>;
    $[1] = animationDelay;
    $[2] = showStroke;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== animationDelay) {
    t5 = <g className="text-neutral-300 dark:text-primary/30"><path d="M144 95.937H48l-.016-1.238C47.327 68.796 26.095 48 0 48V.063h144v95.874Z" fill="currentColor" suppressHydrationWarning={true} style={{
        animation: "logomark-pulse 2s linear infinite",
        animationDelay
      }} /></g>;
    $[4] = animationDelay;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t4 || $[8] !== t5) {
    t6 = <svg viewBox="0 0 144 96" fill="none" xmlns="http://www.w3.org/2000/svg" className={t2}>{t3}{t4}{t5}</svg>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
function _temp() {
  return Math.random();
}
function _temp2() {
  return BLACKSMITH_WORDMARK_RECTS.map(_temp);
}